<template>
  <tr @click="onRowClicked(node)" v-on:dblclick="onRowDblClicked(node)" class="hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out" :style="[!this.node.children ? {'cursor': 'pointer'} : '']">
    <td class="px-3 py-3 text-xs leading-3 text-gray-900 whitespace-nowrap">
      <div class="flex items-center">
        <div class="flex-shrink-0 w-4" v-for="index in level" :key="index">
        </div>
        <a
          href="#"
          @click.prevent="onToggle"
          v-if="isFolder"
        >
          <div v-if="open">
            <svg class="flex-shrink-0 h-4 w-4 mr-2 text-gray-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
            </svg>
          </div>

          <div v-else>
            <svg class="flex-shrink-0 h-4 w-4 mr-2 text-gray-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
        </a>
        <a v-else>
            <svg class="flex-shrink-0 h-4 w-4 mr-2 ml-2 text-gray-800" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
            </svg>
        </a>
        {{node.name}}
      </div>
    </td>

    <template v-for="header in headers">
      <td v-if="header.tag !== 'device'" v-bind:key="node.id + header.tag" class="px-6 py-3 whitespace-nowrap text-xs text-gray-700">
        {{ node.griddata[header.tag] }}
      </td>
    </template>
  </tr>
</template>

<script>
export default {
  name: "p-treedatatablerow",
  props: {
    node: {
      type: Object,
      required: true
    },
    level: {
      required: true
    },
    parentid: {
      type: Number,
      required: false
    },
    headers: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    isFolder() {
      return this.node.children && this.node.children.length
    },
    selected() {
      return this.value === this.node
    }
  },
  methods: {
    onToggle() {
      if (this.isFolder) {
        this.open = !this.open
      }
      this.$parent.toggleNode(this.node, this.open)
    },
    onRowClicked() {
      this.$parent.onRowClicked(this.node)
    },
    onRowDblClicked(obj) {
      this.$parent.onRowDblClicked(obj)
    }
  }
}
</script>
